/**
 * Beacon API errors use RFC 7807 problem details (matches Waypoint).
 */
export interface ProblemDetails {
  type: string;
  title: string;
  status: number;
  detail?: string;
  instance?: string;
}

export class BeaconApiError extends Error {
  public override readonly name = 'BeaconApiError';
  public readonly status: number;
  public readonly problem: ProblemDetails;

  constructor(problem: ProblemDetails) {
    super(`${problem.title}${problem.detail ? `: ${problem.detail}` : ''}`);
    this.status = problem.status;
    this.problem = problem;
  }
}
